import React, { useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import * as appUtilityFunction from '../../../../infrastructure/apputilityfunctions'
import securityService from '../../../../services/securityservice'
import  * as appConstants from '../../../../overrides/appconstants'

export default function Table({ dashboardId }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dashboardData = useSelector(
        state => state.dashboardReducer.userDashboard.userdashboardData
    );
    const [searchQuery, setSearchQuery] = useState("");

    if (dashboardData === null) {
        return <div />;
    }

    const datas = dashboardData[dashboardId];
    const dataRows = datas.dataRows;

    if (dataRows.length === 0) {
        return <div />;
    }

    const getFieldNames = () => {
        const fieldNames = dataRows.reduce((uniqueNames, item) => {
            item.fields.forEach(field => {
                if (!uniqueNames.includes(field.fieldName)) {
                    uniqueNames.push(field.fieldName);
                }
            });
            return uniqueNames;
        }, []);
        return fieldNames;
    };

    /* const getFieldValue = (item, fieldName) => {
         const field = item.fields.find(field => field.fieldName === fieldName);
         return field ? field.fieldValue : '';
       };
       */
    const getFieldValue = (item, fieldName) => {
        const field = item.fields.find(field => field.fieldName === fieldName);
        if (field && appUtilityFunction.isDate(field.fieldValue)) {
            return appUtilityFunction.formatDate(field.fieldValue);
        }
        return field ? field.fieldValue : '';
    };

    const filteredDataRows = dataRows.filter(item => {
        return getFieldNames().some(fieldName => {
            const fieldValue = getFieldValue(item, fieldName);
            return fieldValue && fieldValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });

    const onNavigate = (url, quotationNo) => {
        var quoteNo = quotationNo;
        var pagetoRedirect = url.substring(url.indexOf("/") + 1);
        const systemId = url.substring(0, url.indexOf("/"));
        var systemUrl = securityService.getSystemUrlFromSystemId(systemId);
        window.location.href = systemUrl + pagetoRedirect;
    }

    return (
        <div className="col-xl-12" key={dashboardId}>
            <div className="card">
                <div className="card-body py-0" data-simplebar data-simplebar-primary style={{ 'max-height': '500px' }}>
                <div className="d-flex align-items-center justify-content-between alert alert-primary" role="alert">
                        <h4> <i className='mdi mdi-clipboard-flow-outline'></i> {datas.dashboardTitle} </h4>
                        <input
                            type="text"
                            className="form-control w-25"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <table className="table table-bordered table-striped table-centered mb-0">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                {getFieldNames().map(fieldName => (
                                    fieldName == 'LINKURL' ? '':
                                    <th key={fieldName}>{fieldName}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDataRows.length > 0 ?
                                filteredDataRows.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        {getFieldNames().map(fieldName => (
                                            fieldName == 'LINKURL' ? '':
                                            <td key={`${fieldName}-${index}`}>
                                                {fieldName === 'STAGE' ? (
                                                    <span className={appUtilityFunction.getStatusBadge(getFieldValue(item, fieldName))}>
                                                        {String(getFieldValue(item, fieldName))}
                                                    </span>
                                                ) : fieldName === 'QUOTENO' ||   fieldName === 'POLICYNO' || fieldName === 'REQUESTNUMBER'? 
                                                
                                                <a style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => onNavigate(String(getFieldValue(item, 'LINKURL')), String(getFieldValue(item, fieldName)) )}>  {String(getFieldValue(item, fieldName))}</a>
                                                
                                                : (
                                                    String(getFieldValue(item, fieldName))
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                )) : <tr><td colSpan={getFieldNames().length + 1}>No results found</td></tr>
                                }
                        </tbody>
                        {/* <tbody>
                            {dataRows.length > 0 &&
                                dataRows.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        {getFieldNames().map(fieldName => (
                                            <td key={`${fieldName}-${index}`}>
                                                {fieldName === 'STAGE' ? (
                                                    <span className={appUtilityFunction.getStatusBadge(getFieldValue(item, fieldName))}>
                                                        {String(getFieldValue(item, fieldName))}
                                                    </span>
                                                ) : (
                                                    String(getFieldValue(item, fieldName))
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                        </tbody> */}
                    </table>
                </div>
            </div>
        </div>
    );
}
